import './scss/loading.scss';

export const PlaceholderTemplate = (): React.JSX.Element => <div className="page-loading" />;
